import type { RootState } from 'react-redux';
import type { SeoState } from './slice';
import { createSelector } from '@reduxjs/toolkit';

export const getSeo = (state: RootState) => state.seo;
export const getSEOData = createSelector(getSeo, (state: SeoState) => {
  return state?.data;
});
